var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKerbal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 21,8 a 4.9999997,4.9999997 0 0 0 -5,5 4.9999997,4.9999997 0 0 0 5,5 4.9999997,4.9999997 0 0 0 5,-5 4.9999997,4.9999997 0 0 0 -5,-5 z m 22,0 a 4.9999997,4.9999997 0 0 0 -5,5 4.9999997,4.9999997 0 0 0 5,5 4.9999997,4.9999997 0 0 0 5,-5 4.9999997,4.9999997 0 0 0 -5,-5 z M 9.5,25 A 6.5000002,8.9999996 0 0 0 3,34 6.5000002,8.9999996 0 0 0 9.5,43 6.5000002,8.9999996 0 0 0 16,34 6.5000002,8.9999996 0 0 0 9.5,25 Z m 45,0 a 6.5,8.9999996 0 0 0 -6.5,9 6.5,8.9999996 0 0 0 6.5,9 6.5,8.9999996 0 0 0 6.5,-9 6.5,8.9999996 0 0 0 -6.5,-9 z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#868686"
    },
    d: "M 21 7 A 4.9999997 4.9999997 0 0 0 16 12 A 4.9999997 4.9999997 0 0 0 21 17 A 4.9999997 4.9999997 0 0 0 26 12 A 4.9999997 4.9999997 0 0 0 21 7 z M 43 7 A 4.9999997 4.9999997 0 0 0 38 12 A 4.9999997 4.9999997 0 0 0 43 17 A 4.9999997 4.9999997 0 0 0 48 12 A 4.9999997 4.9999997 0 0 0 43 7 z M 9.5 24 A 6.5000002 8.9999996 0 0 0 3 33 A 6.5000002 8.9999996 0 0 0 9.5 42 A 6.5000002 8.9999996 0 0 0 16 33 A 6.5000002 8.9999996 0 0 0 9.5 24 z M 54.5 24 A 6.5 8.9999996 0 0 0 48 33 A 6.5 8.9999996 0 0 0 54.5 42 A 6.5 8.9999996 0 0 0 61 33 A 6.5 8.9999996 0 0 0 54.5 24 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#ffffff"
    },
    d: "M 21 7 A 4.9999997 4.9999997 0 0 0 16 12 A 4.9999997 4.9999997 0 0 0 16.027344 12.515625 A 4.9999997 4.9999997 0 0 1 21 8 A 4.9999997 4.9999997 0 0 1 25.972656 12.484375 A 4.9999997 4.9999997 0 0 0 26 12 A 4.9999997 4.9999997 0 0 0 21 7 z M 43 7 A 4.9999997 4.9999997 0 0 0 38 12 A 4.9999997 4.9999997 0 0 0 38.027344 12.515625 A 4.9999997 4.9999997 0 0 1 43 8 A 4.9999997 4.9999997 0 0 1 47.972656 12.484375 A 4.9999997 4.9999997 0 0 0 48 12 A 4.9999997 4.9999997 0 0 0 43 7 z M 9.5 24 A 6.5000002 8.9999996 0 0 0 3 33 A 6.5000002 8.9999996 0 0 0 3.015625 33.398438 A 6.5000002 8.9999996 0 0 1 9.5 25 A 6.5000002 8.9999996 0 0 1 15.984375 33.601562 A 6.5000002 8.9999996 0 0 0 16 33 A 6.5000002 8.9999996 0 0 0 9.5 24 z M 54.5 24 A 6.5 8.9999996 0 0 0 48 33 A 6.5 8.9999996 0 0 0 48.015625 33.398438 A 6.5 8.9999996 0 0 1 54.5 25 A 6.5 8.9999996 0 0 1 60.984375 33.601562 A 6.5 8.9999996 0 0 0 61 33 A 6.5 8.9999996 0 0 0 54.5 24 z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 5,
    x: 16,
    y: 54,
    rx: 2.5,
    ry: 2.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 33,
    r: 25,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#e4e4e4"
    },
    cx: 32,
    cy: 32,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f"
    },
    d: "M 53,32.142857 C 53,43.819734 43.597979,48 32,48 20.402021,48 11,43.819734 11,32.142857 11,20.46598 20.402021,11 32,11 c 11.597979,0 21,9.46598 21,21.142857 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84bd08"
    },
    d: "M 28.210938 15.236328 C 25.194734 15.320378 23.873454 15.908462 20.693359 19.267578 L 20.408203 27.859375 L 20.523438 30.230469 L 20.578125 39.267578 C 20.95459 42.208951 21.096128 44.607727 21.466797 46.488281 C 24.565705 47.527144 28.156507 48 32 48 C 35.986314 48 39.700119 47.491468 42.875 46.369141 C 43.586945 42.703064 42.943958 37.471577 43.482422 33.152344 L 43.705078 27.390625 L 43.306641 20.931641 C 42.290005 16.733827 36.357154 15.017123 31.921875 15.236328 C 30.407883 15.236328 29.216339 15.208318 28.210938 15.236328 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2e2e"
    },
    d: "m 20.029862,21.534376 0.407344,8.49639 C 21.669776,25.653697 18.535208,18.679829 24.590372,18 c 3.098771,-0.347906 3.462749,3.153084 5.581956,3 1.981521,-0.14314 2.011182,-4.835981 7.143586,-3.9 5.747831,1.048215 5.339761,7.519401 6.36442,12.930766 l 0.315892,-8.036388 c 0.08555,-3.464987 -1.292525,-4.58706 -3.202664,-6.035655 C 38.439337,14.451282 35.676336,14 32.000554,14 c -3.713268,-0.243266 -7.814025,0.695722 -10.448245,3.179727 -1.566915,1.417018 -1.619376,2.33293 -1.522447,4.354649 z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 36,
    r: 4,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff"
    },
    cx: 23,
    cy: 35,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.2
    },
    cx: -41,
    cy: 36,
    r: 4,
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 35.5,
    r: 1.5,
    style: {
      fill: "#3f3f3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 24.5,43.5 c 0,0 1.842506,1 7.307617,1 5.46511,0 7.692383,-1 7.692383,-1"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#868686"
    },
    width: 32,
    height: 5,
    x: 16,
    y: 53,
    rx: 2.5,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M 11.011719 31.638672 C 11.007801 31.806737 11 31.973565 11 32.142578 C 11 43.819455 20.402021 48 32 48 C 43.597979 48 53 43.819455 53 32.142578 C 53 31.973565 52.992199 31.806737 52.988281 31.638672 C 52.721838 42.933785 43.430302 47 32 47 C 20.569698 47 11.278162 42.933785 11.011719 31.638672 z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -41,
    cy: 35,
    r: 4,
    transform: "scale(-1,1)",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3f3f3f"
    },
    cx: -42.5,
    cy: 35.5,
    r: 1.5,
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#ffffff"
    },
    d: "M 32 7 A 25 25 0 0 0 7 32 A 25 25 0 0 0 7.0214844 32.585938 A 25 25 0 0 1 32 8 A 25 25 0 0 1 56.978516 32.414062 A 25 25 0 0 0 57 32 A 25 25 0 0 0 32 7 z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKerbal);
export default __webpack_public_path__ + "static/media/kerbal.3886e4e2d35c565d43b6ce7b3e4c9094.svg";
export { ForwardRef as ReactComponent };